import React from 'react'
import Modal from 'src/components/riders/rider-portal/common/Modal'
import Divider from 'src/components/ui/Divider'
import Cross from 'src/components/icons/ui/Cross'
import { ISavedLocations } from 'src/types'
import SavedLocationItem from 'src/components/riders/rider-portal/trips/create/Step1/SavedLocationItem'

interface IRecentLocationModalProps {
  locations: ISavedLocations[]
  modalTitle: string
  open: boolean
  handleClose: () => void
  handleSelectRecentLocation: (location: ISavedLocations) => void
}

const RecentLocationModal = ({
  locations,
  modalTitle,
  open,
  handleClose,
  handleSelectRecentLocation
}: IRecentLocationModalProps) => (
  <Modal isOpen={open} width={768} onClose={handleClose}>
    <>
      <div className='flex items-center justify-between rp-p16'>
        <h3 className='font-black1 font-medium my0 rp-pr24 text-lg'>{modalTitle}</h3>
        <Cross className='icon--18x18 svg-color-black1' onClick={handleClose} />
      </div>
      <Divider />
      <div className='rp-p16 rp-save-locations-wrapper'>
        {locations.map(location => (
          <SavedLocationItem
            key={location.id}
            location={location}
            handleSelectRecentLocation={handleSelectRecentLocation}
          />
        ))}
      </div>
    </>
  </Modal>
)

export default RecentLocationModal



// WEBPACK FOOTER //
// ./src/components/riders/rider-portal/trips/create/Step1/RecentLocationModal.tsx